import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { HttpRequest } from "@smithy/protocol-http";
import { getDateHeader, getSkewCorrectedDate, getUpdatedSystemClockOffset } from "../utils";
var throwSigningPropertyError = function throwSigningPropertyError(name, property) {
  if (!property) {
    throw new Error("Property `".concat(name, "` is not resolved for AWS SDK SigV4Auth"));
  }
  return property;
};
export var validateSigningProperties = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signingProperties) {
    var _context$endpointV, _context$endpointV$pr, _context$endpointV$pr2;
    var context, config, authScheme, signerFunction, signer, signingRegion, signingRegionSet, signingName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = throwSigningPropertyError("context", signingProperties.context);
            config = throwSigningPropertyError("config", signingProperties.config);
            authScheme = (_context$endpointV = context.endpointV2) === null || _context$endpointV === void 0 ? void 0 : (_context$endpointV$pr = _context$endpointV.properties) === null || _context$endpointV$pr === void 0 ? void 0 : (_context$endpointV$pr2 = _context$endpointV$pr.authSchemes) === null || _context$endpointV$pr2 === void 0 ? void 0 : _context$endpointV$pr2[0];
            signerFunction = throwSigningPropertyError("signer", config.signer);
            _context.next = 6;
            return signerFunction(authScheme);
          case 6:
            signer = _context.sent;
            signingRegion = signingProperties === null || signingProperties === void 0 ? void 0 : signingProperties.signingRegion;
            signingRegionSet = signingProperties === null || signingProperties === void 0 ? void 0 : signingProperties.signingRegionSet;
            signingName = signingProperties === null || signingProperties === void 0 ? void 0 : signingProperties.signingName;
            return _context.abrupt("return", {
              config: config,
              signer: signer,
              signingRegion: signingRegion,
              signingRegionSet: signingRegionSet,
              signingName: signingName
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function validateSigningProperties(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var AwsSdkSigV4Signer = /*#__PURE__*/function () {
  function AwsSdkSigV4Signer() {
    _classCallCheck(this, AwsSdkSigV4Signer);
  }
  _createClass(AwsSdkSigV4Signer, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(httpRequest, identity, signingProperties) {
        var _handlerExecutionCont, _handlerExecutionCont2;
        var validatedProps, config, signer, signingRegion, signingName, handlerExecutionContext, _handlerExecutionCont3, first, second, _second$signingRegion, _second$signingName, signedRequest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (HttpRequest.isInstance(httpRequest)) {
                  _context2.next = 2;
                  break;
                }
                throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
              case 2:
                _context2.next = 4;
                return validateSigningProperties(signingProperties);
              case 4:
                validatedProps = _context2.sent;
                config = validatedProps.config, signer = validatedProps.signer;
                signingRegion = validatedProps.signingRegion, signingName = validatedProps.signingName;
                handlerExecutionContext = signingProperties.context;
                if ((_handlerExecutionCont = handlerExecutionContext === null || handlerExecutionContext === void 0 ? void 0 : (_handlerExecutionCont2 = handlerExecutionContext.authSchemes) === null || _handlerExecutionCont2 === void 0 ? void 0 : _handlerExecutionCont2.length) !== null && _handlerExecutionCont !== void 0 ? _handlerExecutionCont : 0 > 1) {
                  _handlerExecutionCont3 = _slicedToArray(handlerExecutionContext.authSchemes, 2), first = _handlerExecutionCont3[0], second = _handlerExecutionCont3[1];
                  if ((first === null || first === void 0 ? void 0 : first.name) === "sigv4a" && (second === null || second === void 0 ? void 0 : second.name) === "sigv4") {
                    signingRegion = (_second$signingRegion = second === null || second === void 0 ? void 0 : second.signingRegion) !== null && _second$signingRegion !== void 0 ? _second$signingRegion : signingRegion;
                    signingName = (_second$signingName = second === null || second === void 0 ? void 0 : second.signingName) !== null && _second$signingName !== void 0 ? _second$signingName : signingName;
                  }
                }
                _context2.next = 11;
                return signer.sign(httpRequest, {
                  signingDate: getSkewCorrectedDate(config.systemClockOffset),
                  signingRegion: signingRegion,
                  signingService: signingName
                });
              case 11:
                signedRequest = _context2.sent;
                return _context2.abrupt("return", signedRequest);
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function sign(_x2, _x3, _x4) {
        return _sign.apply(this, arguments);
      }
      return sign;
    }()
  }, {
    key: "errorHandler",
    value: function errorHandler(signingProperties) {
      return function (error) {
        var _error$ServerTime;
        var serverTime = (_error$ServerTime = error.ServerTime) !== null && _error$ServerTime !== void 0 ? _error$ServerTime : getDateHeader(error.$response);
        if (serverTime) {
          var config = throwSigningPropertyError("config", signingProperties.config);
          var initialSystemClockOffset = config.systemClockOffset;
          config.systemClockOffset = getUpdatedSystemClockOffset(serverTime, config.systemClockOffset);
          var clockSkewCorrected = config.systemClockOffset !== initialSystemClockOffset;
          if (clockSkewCorrected && error.$metadata) {
            error.$metadata.clockSkewCorrected = true;
          }
        }
        throw error;
      };
    }
  }, {
    key: "successHandler",
    value: function successHandler(httpResponse, signingProperties) {
      var dateHeader = getDateHeader(httpResponse);
      if (dateHeader) {
        var config = throwSigningPropertyError("config", signingProperties.config);
        config.systemClockOffset = getUpdatedSystemClockOffset(dateHeader, config.systemClockOffset);
      }
    }
  }]);
  return AwsSdkSigV4Signer;
}();
export var AWSSDKSigV4Signer = AwsSdkSigV4Signer;